import { AbstractFreewheelClass } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFreewheelClass';
export class AbstractFWGlobalParams extends AbstractFreewheelClass {
    constructor(argument) {
        super({
            name: 'AbstractFWGlobalParams',
            ...argument
        });
    }
    get adParameters() {
        return this.adParams;
    }
}
